import { render, staticRenderFns } from "./ClaimantBookingAttendanceConfirmation.vue?vue&type=template&id=25d23c83"
import script from "./ClaimantBookingAttendanceConfirmation.vue?vue&type=script&lang=js"
export * from "./ClaimantBookingAttendanceConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports